export const environment = {
  production: true,
  baseUrl: 'https://api-rapol.erpat.app'
};
